import { h, type GenericEventHandler } from "preact";
import "./checkbox.scss";

// todo: callback, focus, size

interface Props {
    id: string;
    label?: string;
    checked?: boolean;
    disabled?: boolean;
    state?: "valid" | "invalid";
    onChange?: GenericEventHandler<HTMLInputElement>;
}

export const Checkbox = (props: Props) => {
    return (
        <div class="component-checkbox-container">
            <label for={props.id} class={"component-checkbox" + (props.state ? ` ${props.state}` : "")}>
                <input type="checkbox" id={props.id} disabled={props.disabled} checked={props.checked} onChange={props.onChange} />
                <span />
            </label>
            {
                props.label &&
                <label for={props.id}>
                    {
                        props.label
                    }
                </label>
            }
        </div>
    );
}
